<template>
  <VContent>
    <template slot="right">
      <span>تفاصيل الشركة</span>
    </template>
    <template slot="content">
      <b-table
        :items="items"
        :fields="fields"
        :tbody-transition-props="transProps"
        tbody-tr-class="text-muted"
        responsive
        table-class="table-font h-100"
      >
        <template v-slot:cell(name)="{ item }">
          <img
            :src="ImageURL(item)"
            width="35"
            height="35"
            class="bg-info rounded-circle mx-3"
          />
          {{ item.name }}
        </template>
        <template v-slot:cell(email)="{ item }">
          <div class="p-2 rounded-pill green" v-if="item.email">
            {{ item.email }}
          </div>
          <p v-else>لا يوجد</p>
        </template>
        <template v-slot:cell(status)="{ item }">
          <div
            class="p-2 rounded-pill"
            :class="{
              green: item.status === 1,
              error: item.status === 2,
              pending: item.status !== 1 && item.status !== 2,
            }"
          >
            {{
              item.status === 1
                ? "تم القبول"
                : item.status === 2
                ? "تم الرفض"
                : item.status === 0
                ? "جاري المراجعة"
                : ""
            }}
          </div>
        </template>
        <template v-slot:cell(created_at)="{ item }">{{
          new Date(item.created_at).toISOString().slice(0, 10)
        }}</template>
        <template v-slot:cell(banks)="{ item }">
          {{ item.banks ? item.banks.length : 0 }}
        </template>
        <template v-slot:cell(actions)="{ item }">
          <b-dropdown size="lg" variant="link" no-caret>
            <template #button-content>
              <b-icon icon="three-dots" animation="cylon"></b-icon>
            </template>
            <b-dropdown-item @click="getByID(item, true)">
              <b-icon
                icon="file-earmark-medical"
                scale="0.5"
                class="ml-2"
              ></b-icon>
              عرض</b-dropdown-item>
            <b-dropdown-item @click="getByID(item, false)">
              <b-icon icon="pencil-square" scale="0.5" class="ml-2"></b-icon>
              تعديل</b-dropdown-item>
            <b-dropdown-item @click="openBanksDialog(item)">
              <b-icon icon="building" scale="0.5" class="ml-2"></b-icon>
              الشركات المتعاقدة</b-dropdown-item>
          </b-dropdown>
        </template>
      </b-table>
    </template>
    <template slot="modals">
      <CompanyModal
        :readonly="readonly"
        @close="readonly = false"
      ></CompanyModal>
      <BanksDialog :company="selectedCompany" @close="selectedCompany = null" />
    </template>
  </VContent>
</template>

<script>
import {
  successAlert,
  errorAlert,
  showAlertWithConfirm,
  ImageURL,
} from "@/utils/helper";
import CompanyModal from "./components/companyModal.vue";
import BanksDialog from "./components/BanksDialog.vue";

export default {
  components: { CompanyModal, BanksDialog },
  data() {
    return {
      readonly: false,
      selectedCompany: null,
      transProps: {
        name: "flip-list",
      },
      fields: [
        {
          key: "name",
          label: "أسم الشركة",
          sortable: true,
        },
        {
          key: "email",
          label: "البريد الألكتروني",
          sortable: true,
        },
        {
          key: "phone",
          label: "رقم الهاتف",
          sortable: true,
        },
        {
          key: "address",
          label: "العنوان",
          sortable: true,
        },
        {
          key: "banks",
          label: "عدد البنوك المتعاقدة",
          sortable: true,
        },
        {
          key: "status",
          label: "الحالة",
          sortable: true,
        },
        {
          key: "actions",
          label: "العمليات",
          sortable: true,
        },
      ],
    };
  },
  computed: {
    items() {
      const form = this.$store.state.company.companyInfo.form;
      return form ? [form] : []; // Ensure form is defined before accessing it
    },
  },
  mounted() {
    this.getAll();
  },
  methods: {
    getAll() {
      this.$store
        .dispatch("company/companyInfo/get")
        .catch(() => errorAlert("Failed to fetch company info."));
    },
    getByID(item, status) {
      this.$store
        .dispatch("company/companyInfo/show", item)
        .then(() => {
          this.readonly = status;
          this.$bvModal.show("company-modal");
        })
        .catch(() => errorAlert());
    },
    ImageURL(item) {
      return item.logo ? item.logo : ImageURL("user.jpg");
    },
    openBanksDialog(item) {
      this.selectedCompany = item;
      this.$bvModal.show("banks-dialog");
    },
  },
};
</script>

<style lang="scss">
td[aria-colindex="1"] {
  text-align: right;
}

td[aria-colindex="2"] {
  text-align: center;
}

td[aria-colindex="3"] {
  direction: ltr;
}

td[aria-colindex="5"] {
  overflow-x: hidden;
  width: 200px;
}
</style>
